export default {"src":"/_next/static/media/icon_01.0f3d8666.svg","height":44,"width":44};